export default {
    buyerCenter: {
        Message: {
                delete: {
                success: 'Deleted successfully!'
            }
        },
        Description: {
            module1: {
                title: 'Purchase Orders',
                more: 'View All',
                status: [
                    'Pending Confirmation',
                    'Pending Payment',
                    'Pending Shipment',
                    'Processing', // Alternative: "Pending Preparation"
                    'Pending Delivery',
                    'Pending Pickup',
                    'Returns/ Refunds'
                ],
                item: {
                    text1: 'Order No.:',
                    text2: 'Remaining ',
                    text3: 'Balance Unpaid',
                    text4: 'Pay Now',
                    text5: 'Pay Balance',
                    text6: 'Confirm Receipt',
                    text7: 'Confirm Pickup',
                    text8: 'Order Details',
                    text9: 'After-sales Details',
                    text10: 'Cancel Order',
                    text11: 'Request Refund',
                    text12: 'Delete Order',
                    text13: 'Total ',
                    text14: ' items'
                }
            },
            module2: {
                title: 'My Favorites',
                more: 'View All',
                item: {
                    text1: 'Total Sales: ',
                    text2: ' orders'
                },
                noData: {
                    text1: 'No favorites yet',
                    text2: 'I want to ',
                    text3: 'add favorites'
                }
            }
        },
        Dialog: {
            title: 'Select Cancellation Reason',
            text: 'Cancelled orders cannot be restored',
            cancel: 'Cancel',
            confirm: 'Confirm',
            message: {
                error: 'Please select a cancellation reason!',
                success: 'Order cancelled successfully!'
            }
        },
        Confirm: {
            cancel: 'Cancel',
            confirm: 'Confirm',
            collectDelete: {
                title: 'Delete Confirmation',
                text: 'Delete this favorite item?'
            },
            orderDelete: {
                title: 'Delete Confirmation',
                text: 'Delete this order?'
            },
            message: {
                title1: 'Receipt Confirmation',
                text1: 'Confirm goods received in good condition per inspection standards?',
                title2: 'Pickup Confirmation',
                text2: 'Confirm goods picked up in good condition per inspection standards?',
                success: 'Receipt confirmed'
            }
        }
    }
}